<template>
    <b-row>
        <b-col cols="12" v-if="! error">
            <ContentOrLoading style="min-height: 500px;">
                <b-row v-if="reserva">
                    <b-col cols="12">
                        <PageTitle 
                            title=""
                        />

                        <CabeceraClubs
                            v-if="reserva.evento.equipo_local"
                            :event="reserva.evento"
                        />

                        <CabeceraImagen
                            v-if="! reserva.evento.equipo_local"
                            :event="reserva.evento"
                        />
                    </b-col>
                    <b-col cols="12">
                        <section class="padding-vertical-content lightgray-content">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <h1>Las entradas son preseleccionadas, no se puede ampliar ni reducir el número.</h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </b-col>
                    <b-col cols="12">
                        <section class="padding-vertical-content lightgray-content">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <DatosCompradoresComponent 
                                            :datos_compradores="datos_compradores" 
                                            :generos="generos" 
                                            v-on:terminar="guardarDatos" 
                                            :solicitar_datos="reserva.evento.solicitar_datos"
                                            :reserva_instalaciones="reserva.evento.reserva_instalaciones"
                                            :asientos="asientos"
                                            :plazas="entradasPlazas"
                                            :desactivar="resumen"
                                            :lfp="false"
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </b-col>
                    <b-col cols="12">
                        <section class="padding-vertical-content" v-if="resumen" key="resumen" id="resumen">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <h2 class="m-0 h1 text-uppercase">{{ $t('partido.resumen_compra') }}</h2>
                                        <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('partido.revisa_datos') }}.</div>
                                        <ResumenCompraComponent 
                                            :entradas="asientos"
                                            :entradasPlazas="entradasPlazas"
                                            :formulario="formulario"
                                            :event="reserva.evento"
                                            :datos="datos_compradores"
                                            :session_id="session_id"
                                            @terminado="procesarPago"
                                            @volver="volver()"
                                            :desactivar="procesar_pago ? true : false"
                                            :voucher="voucher"
                                        />					
                                    </div>
                                </div>
                            </div>
                        </section>
                    </b-col>
                    <b-col cols="12">
                        <section class="padding-vertical-content lightgray-content" v-if="procesar_pago" key="pago" id="pago">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                                        <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                                        <PagoPaycometComponent
                                            ref="pago"
                                            tipo_venta="evento"
                                            :jet_id="jet_id"
                                            :session_id="session_id"
                                        />		
                                    </div>
                                </div>
                            </div>
                        </section>
                    </b-col>
                </b-row>
                <b-row v-if="comprado">
                    <b-col cols="12">
                        <PageTitle 
                            title="Ya se han comprado las entradas de este enlace."
                        />
                    </b-col>
                    <b-col cols="12">
                        
                    </b-col>
                </b-row>
            </ContentOrLoading>
        </b-col>
        <b-col v-else>
            <NotFoundComponent/>
        </b-col>
    </b-row>
</template>

<script>
import PageTitle from '@/components/frontend/shared/PageTitle';
import NotFoundComponent from '@/components/frontend/errors/NotFoundComponent.vue';
import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs.vue';
import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen.vue';
import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent.vue';
import Generos from "@/mixins/Generos";
import ResumenCompraComponent from '@/components/frontend/events/compra/ResumenCompraComponent';
import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';

export default {
    props: ['hash'],
    mixins: [Generos],
    data() {
        return {
            reserva: null,
            error: false,
            datos_compradores: {},
            asientos: [],
            entradasPlazas: [],
            jet_id: null,
            formulario: null,
            resumen: false,
            session_id: null,
            procesar_pago: false,
            voucher: null,
            comprado: false
        }
    },
    mounted() {
        this.getInfoReserva();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        getInfoReserva() {
            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                hash: this.hash
            };
            this.$store.dispatch(this.config.getVuexAlias('front.reservas.info'), params).then(res => {
                this.reserva = res.data.data;

                if (this.reserva.butacas && this.reserva.butacas.length > 0) {
                    this.reserva.butacas.forEach(butaca => {
                        this.asientos.push({
                            asiento: butaca,
                            precios: butaca.precios,
                            descuento: this.reserva.descuento,
                            precio: butaca.precio
                        })
                    });
                }

                if (this.reserva.plazas && this.reserva.plazas.length > 0) {
                    this.reserva.plazas.forEach(butaca => {
                        butaca.descuento = this.reserva.descuento;
                        this.asientos.push(butaca);
                    });
                }

                this.datos_compradores.email = this.reserva.email;

                if(this.reserva.descuento) {
                    this.voucher = {
                        discount_percent: this.reserva.descuento,
                        units: 100,
                        code: 'Venta personalizada'
                    }
                }
            }).catch(error => {
                if(error.response.status == 400) {
                    this.comprado = true;
                } else {
                    this.error = true;
                }                
            });            
        },
        guardarDatos() {
            this.asientos.forEach(asiento => {
                if (asiento.precio === null) {
                    asiento.precio = asiento.precioSeleccionado;
                }
            });
            this.datos_compradores.asientos = this.asientos;

            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                hash: this.hash,
                datos_compradores: this.datos_compradores
            };

            if (this.reserva.plazas.length > 0) {
                params.plazas = this.asientos;
            } else {
                params.butacas = this.asientos;
            }

            this.$store.dispatch(this.config.getVuexAlias('front.reservas.guardar.datos'), params).then(res => {
                this.jet_id = res.data.jet_id;
                this.session_id = res.data.data.session_id;
                this.formulario = res.data.formulario;
                this.resumen = true;
                this.$nextTick(function() {
                    this.scrollTo('#resumen');
                });
            }).catch(error => {
                console.log(error.response);
            });
        },
        volver() {

        },
        procesarPago(precio_cero = false) {
            if (precio_cero) {
                this.procesarCompraPrecioCero();
            } else {
                this.procesar_pago = true;
                this.$nextTick(() => {
                    this.scrollTo('#pago')
                })
            }
        },
        procesarCompraPrecioCero() {
            const params = {
                filters: {},
                carrito_id: this.session_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.events.procesar-compra-precio-cero'), params).then(res => {
                this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
            }).finally(() => this.loading = false);
        },
        scrollTo(paso) {
            this.$scrollTo(paso, 100)
        },
    },
    components: {
        PageTitle, NotFoundComponent, CabeceraClubs, CabeceraImagen, DatosCompradoresComponent, ResumenCompraComponent, PagoPaycometComponent
    }
}
</script>